import React from "react";

export const STATUS = {
  draft: { label: "Draft", cls: "bg-slate-100 text-slate-700 ring-slate-200" },
  approved: { label: "Approved", cls: "bg-sky-100 text-sky-800 ring-sky-200" },
  scheduled: { label: "Scheduled", cls: "bg-indigo-100 text-indigo-800 ring-indigo-200" },
  posting: { label: "Posting…", cls: "bg-amber-100 text-amber-800 ring-amber-200" },
  posted: { label: "Posted", cls: "bg-emerald-100 text-emerald-800 ring-emerald-200" },
  failed: { label: "Failed", cls: "bg-red-100 text-red-700 ring-red-200" },
};
export const LANGS = [{ v: "en", l: "English" }, { v: "hi", l: "हिन्दी · Hindi" }, { v: "mr", l: "मराठी · Marathi" }];
export const LANG_SHORT = { en: "EN", hi: "हि", mr: "म" };
export const POST_TYPES = ["Admission Open", "Results & Toppers", "Festival Greeting", "Study Tips", "Event / Activity", "Parent Testimonial", "General"];
export const POSTER_STYLES = ["Admission", "Results", "Festival", "Classroom", "Event", "Motivation"];

export const errMsg = (e, d = "Something went wrong") => {
  const x = e?.response?.data?.detail;
  return typeof x === "string" ? x : d;
};

export const toLocalIST = (iso) => {
  if (!iso) return "";
  const parts = new Intl.DateTimeFormat("en-GB", { timeZone: "Asia/Kolkata", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hour12: false }).formatToParts(new Date(iso));
  const g = (t) => parts.find((p) => p.type === t)?.value;
  return `${g("year")}-${g("month")}-${g("day")}T${g("hour") === "24" ? "00" : g("hour")}:${g("minute")}`;
};

export const StatusBadge = ({ status, test, testId }) => {
  const s = STATUS[status] || STATUS.draft;
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-[11px] font-bold ring-1 ${s.cls}`}>
      {s.label}{status === "posted" && test ? " · TEST" : ""}
    </span>
  );
};
